import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'WuFoo form embed',
  name: 'wuFooForm',
  type: 'object',
  fields: [
    defineField({
      name: 'title',
      title: 'Title',
      description: `Form identifier within sanity. Doesn't render on the frontend`,
      type: 'string',
    }),
    defineField({
      name: 'embedCode',
      title: 'Embed code',
      description: 'Use Iframe embed method from WoFoo',
      type: 'text',
      validation: (rule) => rule.required(),
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title }) {
      return {
        title: title || 'Untitled',
        subtitle: 'WuFoo form embed',
      }
    },
  },
})